import { useSearchParams, Link } from "react-router-dom";
import { articles, siteMeta } from "@/mocks/chigua";
import useSeo from "@/hooks/useSeo";
import Breadcrumbs from "@/components/chigua/Breadcrumbs";
import StoryCard from "@/components/chigua/StoryCard";
import JsonLd from "@/components/chigua/JsonLd";

export default function Search() {
  const [params] = useSearchParams();
  const kw = (params.get("kw") || "").trim();
  const results = kw
    ? articles.filter((a) => {
        const hay = `${a.title} ${a.excerpt} ${a.dek} ${a.tags.join(" ")} ${a.sections.map((s) => s.heading).join(" ")}`.toLowerCase();
        return hay.includes(kw.toLowerCase());
      })
    : [];

  useSeo({
    title: kw ? `搜索“${kw}”-今日吃瓜` : "站内搜索-今日吃瓜",
    description:
      "在今日吃瓜站内搜索圈内热点、内幕深扒与内幕真相的相关复盘内容，快速定位你关心的线索与时间线。",
    path: `/search?kw=${encodeURIComponent(kw)}`,
  });

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "站内搜索-今日吃瓜",
    url: `${siteMeta.domain}/search`,
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: { "@type": "EntryPoint", urlTemplate: `${siteMeta.domain}/search?kw={search_term_string}` },
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <div className="mx-auto max-w-[1000px] px-4 md:px-6">
      <JsonLd data={schema} />
      <Breadcrumbs items={[{ label: "站内搜索" }]} />

      <header className="border-b border-background-200 py-6">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          搜索<span className="text-primary-600">“{kw || "全部"}”</span>
        </h1>
        <p className="mt-2 text-sm text-foreground-500">
          找到 <strong className="text-foreground-800">{results.length}</strong> 篇与关键词相关的圈内内容与复盘
        </p>
      </header>

      {kw ? (
        results.length ? (
          <div className="grid gap-6 pb-16 pt-8 sm:grid-cols-2">
            {results.map((a) => (
              <StoryCard key={a.slug} item={a} />
            ))}
          </div>
        ) : (
          <div className="py-20 text-center">
            <span className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-background-100 text-3xl text-foreground-300">
              <i className="ri-search-eye-line" aria-hidden="true" />
            </span>
            <h2 className="mt-5 font-heading text-xl font-bold text-foreground-950">没有找到相关结果</h2>
            <p className="mt-2 text-sm text-foreground-500">换个关键词试试，或直接前往深扒档案浏览全部复盘。</p>
            <Link to="/list/shenba" className="mt-6 inline-flex whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50">
              浏览深扒档案
            </Link>
          </div>
        )
      ) : (
        <div className="py-20 text-center text-foreground-500">
          <span className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-background-100 text-3xl text-foreground-300">
            <i className="ri-search-line" aria-hidden="true" />
          </span>
          <p className="mt-5 text-sm">请在顶栏搜索框输入关键词，检索站内圈内线索与复盘内容。</p>
        </div>
      )}
    </div>
  );
}